import { NinjaWhite } from '@repo/ui/components/platforms/ninja-white'
import './header-icon.scss'

export function HeaderIcon() {
  return (
    <div className="header-ck-logo">
      <div className="long-ck-logo">
        <NinjaWhite style={{ width: 36, height: 36 }} className="rounded-lg" />
      </div>
    </div>
  )
}
